var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"images-loaded",rawName:"v-images-loaded",value:(_vm.onImgLoad),expression:"onImgLoad"}],staticClass:"view-pic-img",class:_vm.stateClasses,attrs:{"src":_vm.imgPath,"alt":_vm.renderedTitle,"title":_vm.renderedTitle}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa77cb44","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/snippets/PicImg.vue
// module id = 394
// module chunks = 0